/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult } from "@scopely/web-sdk-scopely-account/dist/src/common/apiResult";
import { AudiencesAuthorizationResult } from "@scopely/web-sdk-scopely-account/dist/src/oauth2/model/AudiencesAuthorizationResult";
import { LoginResult, LogoutResult } from "@scopely/web-sdk-scopelyid";
import { createContext } from "react";

/* eslint-disable */
export enum ConnectionStatus {
	UNKNOWN = "unknown",
	CONNECTED = "connected"
}

export interface IScopelyIdentityContext {
	connectionStatus: ConnectionStatus;
	isConnected: boolean;
	isScopelyIdentityReady: boolean;
	initiateLogin(origPath: string): Promise<void>;
	loginRedirect(onSuccess?: () => void): Promise<LoginResult | null>;
	initiateLogout(logoutActionType: string, origPath: string): Promise<void>;
	logoutRedirect(onSuccess?: () => void): Promise<LogoutResult | null>;
	resetScopelyIdentity(clearPkce?: boolean, tenant?: string): Promise<void>;
	/** @deprecated use initiateLogin instead */
	startLogin(origPath: string): Promise<void>;
	/** @deprecated use initiateLogout instead */
	startLogout(logoutActionType: string, origPath: string): Promise<void>;
	/** @deprecated use loginRedirect instead */
	tryConcludeLogin(onSuccess?: () => void): Promise<LoginResult | null>;
	/** @deprecated use logoutRedirect instead */
	tryConcludeLogout(onSuccess?: () => void): Promise<LogoutResult | null>;
	setScopelyAccessToken(sidAccessToken: string | null): void;
	setScopelyIdentityToken(sidIdentityToken: string | null): void;
	setScopelyIdToken(sidIdentityToken: string | null): void;
	sidAccessToken: string | null;
	sidIdentityToken: string | null;
	scopelyIdentityToken: string | null;
	setRedirectTo: React.Dispatch<React.SetStateAction<string | undefined>>;
}
/* eslint-enable */

export const ScopelyIdentityContext = createContext<IScopelyIdentityContext>({
	connectionStatus: ConnectionStatus.UNKNOWN,
	isConnected: false,
	isScopelyIdentityReady: false,
	// eslint-disable-next-line
	initiateLogin: async (origPath: string) => undefined,
	loginRedirect: async () => null,
	// eslint-disable-next-line
	initiateLogout: async (logoutActionType: string, origPath: string) => {
		// noop
	},
	logoutRedirect: async () => null,
	resetScopelyIdentity: async () => undefined,
	// eslint-disable-next-line
	startLogin: async (origPath: string) => undefined,
	// eslint-disable-next-line
	startLogout: async (logoutActionType: string, origPath: string) => {
		// noop
	},
	tryConcludeLogin: async () => null,
	tryConcludeLogout: async () => null,
	// eslint-disable-next-line
	setScopelyAccessToken: (sidAccessToken: string) => {
		// noop
	},
	// eslint-disable-next-line
	setScopelyIdentityToken: (sidIdentityToken: string) => {
		// noop
	},
	// eslint-disable-next-line
	setScopelyIdToken: (sidIdentityToken: string) => {
		// noop
	},
	sidAccessToken: null,
	sidIdentityToken: null,
	scopelyIdentityToken: null,
	setRedirectTo: () => {}
});
